import { render, staticRenderFns } from "./AddJcsatOnlinePayment.vue?vue&type=template&id=4e4ff8fe&scoped=true"
import script from "./AddJcsatOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddJcsatOnlinePayment.vue?vue&type=script&lang=js"
import style0 from "./AddJcsatOnlinePayment.vue?vue&type=style&index=0&id=4e4ff8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ff8fe",
  null
  
)

export default component.exports